<template>
  <div v-if="comShortShow">
    <div id="homePage-1" :style="{backgroundImage:'url(' +(combackgroundImage)+')',color:(comShortInfoColor||'#666'),backgroundSize:(comShortImgSize)}">
      <div class="page-left" :style="{marginLeft:comShortLeft}">
        <h1>
          <span  v-if="title">{{ title }}</span>
        </h1>
        <h3 class="info" >{{info}}</h3>
        <!-- <a v-if="linkBtnShow" v-bind:href="weblink" class="view-detail">查看详情</a> -->
      </div>
      <div class="page-right">
        <img v-if="img" :src="require('../../../assets/img/'+img)" alt="sanereman">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageOne',
  data () {
    return {
      title: '金米云（深圳）',
      info: `金米云（深圳）技术有限公司成立于2020年，专注为下沉市场中小企业提供综合的跨境企业服务和供应链解决方案。
金米云（深圳）技术有限公司依托其母公司“香港金米技术有限公司”，凭借大数据核心优势和人工智能、区块链技术，依托专业的海外团队，建立高扩展度的企业服务平台，形成跨境产业生态系统。`,
      linkBtnShow: false,
      img:""//~assets/img/banner/banner_2.5D.png
    }
  },
  mounted(){
    console.error(this.configData);
    if(this.configData){
      this.title=this.configData.comShortName;
      this.info=this.configData.comShortInfo;
      this.combackgroundImage=require("../../../assets/img/"+this.configData.comShortInfoBackgroundImg);
      this.img=this.configData.comShortImg;
      this.comShortInfoColor=this.configData.comShortInfoColor;
      this.comShortImgSize=this.configData.comShortImgSize
      this.comShortLeft=this.configData.comShortLeft
      this.comShortShow=this.configData.comShortShow
      this.linkBtnShow=this.configData.linkBtnShow;
      this.weblink = this.configData.weblink;
    }
  },
  created () {
    console.error("window",window);
    console.error(this.configData);
    if(this.configData){
      this.title=this.configData.comShortName;
      this.info=this.configData.comShortInfo;
      this.combackgroundImage=require("../../../assets/img/"+this.configData.comShortInfoBackgroundImg);
      this.img=this.configData.comShortImg;
      this.comShortInfoColor=this.configData.comShortInfoColor;
      this.comShortImgSize=this.configData.comShortImgSize
      this.comShortLeft=this.configData.comShortLeft
      this.comShortShow=this.configData.comShortShow
      this.linkBtnShow=this.configData.linkBtnShow;
      this.weblink = this.configData.weblink;
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // width: 1600px;
  width:100%;
  height: 385.5px;
  // background-image: var(--image)
  // object-fit: fill;
  // background-position:left;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: right center;
  color: #666;
  >div {
    margin: auto;
  }
}
.info {
  max-width:600px;
  max-height:180px;
}
.page-left {
  h1 {
    font-size: 58px;
    margin-bottom: 50px;
    @media (min-width:10px){
      font-size: 58px;
    }
    span {
      margin-right: 50px;
    }
  }
  h3 {
    font-size: 21px;
    line-height:36px;
    margin-bottom: 50px;
    text-align: left;
  }
  .view-detail {
    font-size: 16px;
    line-height: 60px;
    display: block;
    width: 216px;
    height: 60px;
    transition: all .3s;
    text-align: center;
    border: 1px solid #666
;
    border-radius: 4px;
    color: #666;
    margin-bottom:15px;
    &:hover {
      color: #072c69;
      background-color: #fff;
    }
  }
}
</style>
